import { AuthUserPermission, UnimplementedPermissions } from '@cibo/core/src/types/AuthTypes/MpxUser'
import { useCallback, useMemo } from 'react'
import { PermissionCheckArgs, checkPermissions } from '../utils'
import { useAuth } from './useAuth'
import { useDebugMode } from './useDebugMode'

export const usePermissions = () => {
  const { userPermissions: backendPermissions } = useAuth()
  const { debugSuppressed } = useDebugMode()
  const isDebugUserOnServer = backendPermissions.includes(AuthUserPermission.DEBUG_USER)
  const isDebugToggleOn = isDebugUserOnServer && !debugSuppressed

  // Only expose debug-only permissions while the debug toggle is on.
  const effectivePermissions = useMemo(
    () => [
      ...backendPermissions.filter(p => !(debugSuppressed && p === AuthUserPermission.DEBUG_USER)),
      ...(isDebugToggleOn ? UnimplementedPermissions : []),
    ],
    [backendPermissions.join(), debugSuppressed, isDebugToggleOn]
  )
  const isDebugUser = effectivePermissions.includes(AuthUserPermission.DEBUG_USER)

  const can = useCallback(
    (props: Omit<PermissionCheckArgs, 'permissions'>) =>
      checkPermissions({ permissions: effectivePermissions, ...props }),
    [effectivePermissions.join()]
  )

  return {
    isDebugUser,
    isDebugUserOnServer,
    permissions: effectivePermissions,
    can,
  }
}
